import { Component, OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { ActivatedRoute } from '@angular/router'
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component'

@Component({
  selector: 'app-download-asset',
  templateUrl: './download-asset.component.html',
  styleUrls: ['./download-asset.component.css'],
  standalone: false
})
export class DownloadAssetComponent implements OnInit {
  filename: string = ''
  title: string = ''
  viewer: boolean = false

  constructor(private route: ActivatedRoute, public dialog: MatDialog) {}

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      var { filename, title, viewer } = data
      this.filename = filename
      this.title = title
      this.viewer = viewer
      this.download()
    })
  }

  download(): void {
    if (this.viewer) {
      this.dialog.open(PdfViewerComponent, {
        data: {
          titulo: this.title,
          url: `assets/docs/${this.filename}`,
        },
        width: '80%',
        height: '90%',
      })
    } else {
      let downloadLink = document.createElement('a')
      downloadLink.setAttribute('download', this.filename)
      downloadLink.href = `assets/docs/${this.filename}`
      document.body.appendChild(downloadLink)
      downloadLink.click()
      downloadLink.remove()
    }
  }
}
